import React, { useState, useEffect, FC } from 'react'
import { Button } from 'antd'

interface IPops {
    /**倒计时多少秒 */
    num?: number
    /**点击之前的效验事件 */
    beforeCheck?: () => boolean | Promise<boolean>
    /**异步获取验证码 */
    getCode: () => Promise<any>
}

const CodeBtn: FC<IPops> = (props) => {
    /**倒计时还剩多少秒 */
    const [count, setCount] = useState(-1)
    /**是否正在倒计时 */
    const [isDowning, setIsDowning] = useState(false)
    useEffect(() => {
        if (count <= 0) {
            setIsDowning(false)
        } else {
            setIsDowning(true)
            setTimeout(() => {
                setCount((count) => {
                    return --count
                })
            }, 1000)
        }
    }, [count])

    const btnClick = async () => {
        if (props.beforeCheck && props.beforeCheck() === false) {
            return
        }
        const res = await props.getCode()
        if (res === true) {
            setCount(props.num as number)
        }
    }

    return (
        <Button
            disabled={isDowning}
            onClick={btnClick}
        >
            {isDowning ? `${count}秒` : "获取验证码"}
        </Button>
    )
}
CodeBtn.defaultProps = {
    num: 60
}
export default CodeBtn
